import { IBundleResponse } from './models/AndromeTV.types';
import { Backend } from './Backend';

export class BundleApi {
  /**
   * Retrieve the bundle with the specified id
   */
  static bundle(backend: Backend, bundleId: string, catalogId?: string): Promise<IBundleResponse> {
    const param = { catalogId };
    const url = backend.makeUrl(`vod/v1/bundle/${encodeURIComponent(bundleId)}`, param);
    return backend.getJson(url, backend.bearer) as Promise<IBundleResponse>;
  }
}
